import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromote = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.51758 13.3335V13.9078C6.51767 13.9633 6.53335 14.0176 6.56282 14.0647C6.59229 14.1117 6.63438 14.1495 6.68428 14.1737C6.73418 14.198 6.78989 14.2078 6.84507 14.2019C6.90025 14.1961 6.95268 14.1749 6.99639 14.1407L14.5176 8.23135C14.5528 8.20363 14.5813 8.16826 14.6009 8.12792C14.6205 8.08758 14.6307 8.04331 14.6307 7.99846C14.6307 7.95362 14.6205 7.90935 14.6009 7.86901C14.5813 7.82867 14.5528 7.7933 14.5176 7.76558L6.99639 1.85684C6.95268 1.82265 6.90025 1.80143 6.84507 1.79559C6.78989 1.78975 6.73418 1.79952 6.68428 1.82379C6.63438 1.84806 6.59229 1.88586 6.56282 1.93287C6.53335 1.97989 6.51767 2.03424 6.51758 2.08972V2.66688",
		stroke: "#002E5F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.77734 13.9072C1.77744 13.9627 1.79312 14.017 1.82259 14.0641C1.85206 14.1111 1.89414 14.1489 1.94404 14.1731C1.99394 14.1974 2.04965 14.2072 2.10483 14.2013C2.16002 14.1955 2.21245 14.1743 2.25616 14.1401L9.77734 8.23135C9.81259 8.20363 9.84109 8.16826 9.86069 8.12792C9.88028 8.08758 9.89046 8.04331 9.89046 7.99847C9.89046 7.95362 9.88028 7.90935 9.86069 7.86901C9.84109 7.82867 9.81259 7.7933 9.77734 7.76558L2.25616 1.85684C2.21245 1.82265 2.16002 1.80143 2.10483 1.79559C2.04965 1.78975 1.99394 1.79952 1.94404 1.82379C1.89414 1.84806 1.85206 1.88586 1.82259 1.93287C1.79312 1.97989 1.77744 2.03424 1.77734 2.08972V13.9072V13.9072Z",
		stroke: "#002E5F",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgPromote);
export default ForwardRef;
